import { AfterViewInit, Component, ComponentRef, InjectionToken, Injector, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CdkPortalOutletAttachedRef, ComponentPortal } from '@angular/cdk/portal';
import { PrintAlias, PrintService } from '~core/utils/print.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  providers: [PrintService],
})
export class InvoiceComponent implements AfterViewInit, OnDestroy {
  @ViewChild('alertContainer') container!: ViewContainerRef;
  componentPortal!: ComponentPortal<unknown>;

  invoiceParams: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private printService: PrintService,
    private _injector: Injector
  ) {}

  ngAfterViewInit(): void {
    this.invoiceParams = this.route.snapshot.params[`invoiceParams`].split(',');
    if (this.invoiceParams) {
      const alias = this.invoiceParams[0] as PrintAlias;
      const component = this.printService.getComponent(alias);
      // TODO Verificar
      // const data = this.invoiceParams.length > 1 && this.printService.getData(this.invoiceParams[1]) || '';
      // const params = {MAT_DIALOG_DATA: data};

      setTimeout(() => {
        this.componentPortal = new ComponentPortal<unknown>(component/*, undefined, this.createInjector(params)*/);
        this.printService.onDataReady();
      }, 1000);
    }
  }

  ngOnDestroy(): void {
    const field = this.invoiceParams && this.invoiceParams[1] || '';
    if (field) {
      // this.printService.clearData(field);
    }
  }

  setContext(component: CdkPortalOutletAttachedRef): void {
    if (this.invoiceParams && this.invoiceParams.length > 1) {
      component = component as ComponentRef<unknown>;
      const field = this.invoiceParams[1];
      component.instance[field] = this.printService.getData(field) || '';
    }
  }

  createInjector(data: { [token: string]: unknown }): Injector {
    const injectorTokens = new WeakMap();
    Object.entries(data).forEach(([token, value]) => {
      injectorTokens.set(new InjectionToken<{}>(token), value);
    });

    return Injector.create({
      parent: this._injector,
      providers: [
        { provide: injectorTokens, useValue: data },
      ],
    });
  }
}
